import React, { useEffect, useState, useRef } from 'react';
import { describeFormErrors, ORDER_FIELD_LABELS } from '../../../lib/formErrors';
import { useDispatch, useSelector } from 'react-redux';
import * as yup from 'yup';
import dayjs from 'dayjs';
import { useFormik } from 'formik';
import { useSnackbar } from 'notistack';
import OrderBookModal from '../../../components/chancemng/obtainorder/OrderBookModal';
import * as fileApi from '../../../lib/api/file';
import * as projectApi from '../../../lib/api/project';
import * as approvalV2Api from '../../../lib/api/approvalV2';
import * as approvalApi from '../../../lib/api/approval';
import AskDialog from '../../../components/common/dialog/AskDialog';
import {
  setOrderLetter,
  unloadOrderLetter,
  viewOrderLetter,
} from '../../../modules/projectModule/orderAdd';
import _ from 'lodash';
import { listOrderLetters } from '../../../modules/projectModule/orderLetters';
import { useChanceStore } from '../../../store/chanceStore'

const normalizeApprovalSteps = (steps, currentUserUuid) => {
  return (steps || [])
    .filter(Boolean)
    .map((value) => value.trim())
    .filter((value) => value && value !== currentUserUuid);
};

const validateApprovalSteps = (steps, currentUserUuid) => {
  const normalized = normalizeApprovalSteps(steps, currentUserUuid);

  if (normalized.length === 0) {
    return '최소 1명의 결재자를 추가하세요.';
  }
  if (normalized.some((value) => value === currentUserUuid)) {
    return '본인을 결재자로 지정할 수 없습니다.';
  }
  if (new Set(normalized).size !== normalized.length) {
    return '같은 결재자를 중복 지정할 수 없습니다.';
  }

  return '';
};

const getLineStepValues = (line, currentUserUuid) => {
  const normalized = normalizeApprovalSteps(
    line?.steps?.map((step) => step.assigneeUsrUuid) || [],
    currentUserUuid,
  );
  return normalized.length > 0 ? normalized : [''];
};


const OrderBookEditModalContainer = ({ roUuid, type, open, handleClose }) => {
  const { enqueueSnackbar } = useSnackbar();
  const [lineId, setLineId] = useState('');
  const [approvalSteps, setApprovalSteps] = useState(['']);
  const [approvalLineList, setApprovalLineList] = useState([]);
  const [approvalLineLoading, setApprovalLineLoading] = useState(false);
  const [approvalStepsError, setApprovalStepsError] = useState('');
  const [finalApprovalAuth, setFinalApprovalAuth] = useState(null);
  const [finalApprovalYn, setFinalApprovalYn] = useState(false);
  const [finalApprovalComment, setFinalApprovalComment] = useState('');
  const dispatch = useDispatch();
  const scollToRef = useRef();
  const [isAuth, setIsAuth] = useState(false);

  const {
    chance,
    receiveOrderInf,
    billInfList,
    salesDetails,
    purchaseDetails,
    user,
    approvalList,
    approvalV2Doc,
    approvalV2Steps,
    approvalV2Actions,
  } = useSelector(({ auth, chanceModule, projectModule, loading }) => ({
    user: auth.user,
    chance: chanceModule.chance.chance,
    receiveOrderInf: projectModule.orderAdd.receiveOrderInf,
    billInfList: projectModule.orderAdd.billInfList,
    salesDetails: projectModule.orderAdd.salesDetails,
    purchaseDetails: projectModule.orderAdd.purchaseDetails,
    approvalList: projectModule.orderAdd.approvalList,
    approvalV2Doc: projectModule.orderAdd.approvalV2Doc,
    approvalV2Steps: projectModule.orderAdd.approvalV2Steps,
    approvalV2Actions: projectModule.orderAdd.approvalV2Actions,
    message: projectModule.orderAdd.message,
    loading: loading['orderAdd/VIEW_ORDER_LETTER'],
  }));

  const billInfListData = useChanceStore(state => state.billInfList)
  const billInvListData = useChanceStore(state => state.billInvList)


  useEffect(() => {
    //수주정보 가져오기
    if (roUuid) {
      dispatch(viewOrderLetter(roUuid));
    }

    //언마운트될때 리덕스에서 파트너 데이터 초기화
    return () => {
      dispatch(unloadOrderLetter());
    };
  }, [dispatch, roUuid]);

  useEffect(() => {
    if (!open) {
      return;
    }

    const fetchApprovalLines = async () => {
      setApprovalLineLoading(true);
      try {
        const res = await approvalV2Api.getApprovalV2Lines({ docType: 'ORDER_BOOK' });
        setApprovalLineList(res.data.list || []);
      } catch (e) {
        enqueueSnackbar('v2 결재선 템플릿 조회 실패', { variant: 'error' });
      } finally {
        setApprovalLineLoading(false);
      }
    };

    fetchApprovalLines();
  }, [enqueueSnackbar, open]);

  useEffect(() => {
    if (!open) {
      return;
    }

    const fetchFinalApprovalAuth = async () => {
      try {
        const res = await approvalV2Api.getMyFinalApprovalAuth({
          docType: 'ORDER_BOOK',
          amount: receiveOrderInf?.roTotalAmt || chance?.totalSales,
        });
        const auth = res.data?.canApprove ? res.data.info : null;
        setFinalApprovalAuth(auth);
        if (!auth) {
          setFinalApprovalYn(false);
        }
      } catch (e) {
        setFinalApprovalAuth(null);
        setFinalApprovalYn(false);
      }
    };

    fetchFinalApprovalAuth();
  }, [chance?.totalSales, open, receiveOrderInf?.roTotalAmt]);

  useEffect(() => {
    if (approvalV2Doc) {
      setLineId(approvalV2Doc.lineId || '');
      setApprovalSteps(
        approvalV2Steps && approvalV2Steps.length > 0
          ? approvalV2Steps.map((step) => step.originalAssigneeUsrUuid).filter(Boolean)
          : ['']
      );
      setApprovalStepsError('');
      return;
    }

    if (open) {
      setLineId('');
      setApprovalSteps(['']);
      setApprovalStepsError('');
    }
  }, [approvalV2Doc, approvalV2Steps, open]);

  useEffect(() => {
//    console.log(receiveOrderInf, 'receiveOrderInf');
  }, [receiveOrderInf]);

  useEffect(() => {
    const findIndex = _.findIndex(
      user?.privilegeList,
      (auth) => auth?.authTyp === 'MINUS_PO' && auth?.authYn === 'Y',
    );
    // console.log(findIndex, 'findIndex');
    if (findIndex !== -1) {
      setIsAuth(true);
    }
  }, [user]);

  const getPercentByTotal = (newValue) => {
    const totalSales = chance?.totalSales; //매출액
    const numberValue = Number(newValue);
    const percent = Math.round((numberValue / totalSales) * 100);
    return percent;
  };

  const initialValues = {
    mtnFreeTm:
      receiveOrderInf && receiveOrderInf.mtnFreeTm !== null
        ? receiveOrderInf.mtnFreeTm
        : '',
    expDay:
      receiveOrderInf && receiveOrderInf.expDay !== null
        ? receiveOrderInf.expDay
        : '',
    siDt:
      receiveOrderInf && receiveOrderInf.siDt !== null
        ? receiveOrderInf.siDt
        : '',

    // 납품 예정일·라이센스 기간이 초기값에 없어서, 수정 창을 열면 화면엔 날짜가 보이는데
    // 실제 값은 비어 있었다(필수 검사에 걸리거나 저장 시 null 로 덮임). 저장된 값으로 채운다.
    dlvryDuedate: receiveOrderInf?.dlvryDuedate || '',
    licStrtDt: receiveOrderInf?.licStrtDt || '',
    licEndDt: receiveOrderInf?.licEndDt || '',

    mtnFreeStrtDt:
      receiveOrderInf && receiveOrderInf.mtnFreeStrtDt !== null
        ? receiveOrderInf.mtnFreeStrtDt
        : '',
    mtnFreeEndDt:
      receiveOrderInf && receiveOrderInf.mtnFreeEndDt !== null
        ? receiveOrderInf.mtnFreeEndDt
        : '',

    collCondt:
      receiveOrderInf && receiveOrderInf.collCondt !== null
        ? receiveOrderInf.collCondt
        : '세금계산서 발행후 익월말',
    payCondt:
      receiveOrderInf && receiveOrderInf.payCondt !== null
        ? receiveOrderInf.payCondt
        : '현금',


    giPrePct:
    receiveOrderInf && receiveOrderInf.giPrePct !== null
      ? receiveOrderInf.giPrePct
      : '',

    giCovPct:
    receiveOrderInf && receiveOrderInf.giCovPct !== null
      ? receiveOrderInf.giCovPct
      : '',

    giMtnPct:
    receiveOrderInf && receiveOrderInf.giMtnPct !== null
      ? receiveOrderInf.giMtnPct
      : '',
              
    comment:
      receiveOrderInf && receiveOrderInf.comment !== null
        ? receiveOrderInf.comment
        : '',
    //최종 매출 이익 (내부거래 포함)
    roProfitAmt:
      receiveOrderInf && receiveOrderInf.roProfitAmt !== null
        ? receiveOrderInf.roProfitAmt
        : chance?.totalProfit,
    roProfitAmtPercent:
      receiveOrderInf && receiveOrderInf.roProfitAmtPercent !== null
        ? receiveOrderInf.roProfitAmtPercent
        : getPercentByTotal(chance?.totalProfit),
    roCostAmt:
      receiveOrderInf && receiveOrderInf.roCostAmt !== null
        ? receiveOrderInf.roCostAmt
        : 0,
    roCostAmtPercent:
      receiveOrderInf && receiveOrderInf.roCostAmtPercent !== null
        ? receiveOrderInf.roCostAmtPercent
        : getPercentByTotal(receiveOrderInf?.roCostAmt),
    roAdjProfitAmt:
      receiveOrderInf && receiveOrderInf.roAdjProfitAmt !== null
        ? receiveOrderInf.roAdjProfitAmt
        : 0,
    roAdjProfitAmtPercent:
      receiveOrderInf && receiveOrderInf.roAdjProfitAmtPercent !== null
        ? receiveOrderInf.roAdjProfitAmtPercent
        : 0,
    roInternalCosts:
      receiveOrderInf && receiveOrderInf?.roInternalCosts !== null
        ? receiveOrderInf.roInternalCosts
        : [
            {
              roPartnerUsrNm: '',
              roPartnerUsr: '',
              roInternalAmt: 0,
              roInternalAmtPercent: 0,
            },
          ],
    files: [{ fileDesc: '', file: null }],
  };

  const validationSchema = yup.object({
    expDay: yup
      .date('계약일을 입력하세요')
      .required('계약일을 입력하세요')
      .nullable()
      .default(undefined),
    siDt: yup
      .date('계약완료일을 입력하세요')
      .required('계약완료일을 입력하세요')
      .nullable()
      .default(undefined),
    // 화면에는 필수(*)로 표시되는데 규칙이 없어서 비워도 그냥 저장됐다.
    // 이 값이 비면 DLVRY_DUE_DT 가 NULL 이 되고 납기 OTD 가 수주 납기를 못 본다.
    dlvryDuedate: yup
      .date('납품 예정일을 입력하세요')
      .required('납품 예정일을 입력하세요')
      .nullable()
      .default(undefined),
    mtnFreeStrtDt: yup
      .date()
      .test(
        'project-mtnFreeStrtDt',
        '무상 유지보수 시작일을 입력하세요',
        function (value) {
          let result = chance?.prjTyp === 'N' && value === null ? false : true;
          return result;
        },
      )
      .nullable()
      .default(undefined),
    mtnFreeEndDt: yup
      .date()
      .test(
        'project-mtnFreeEndDt',
        '무상 유지보수 종료일을 입력하세요',
        function (value) {
          let result = chance?.prjTyp === 'N' && value === null ? false : true;
          return result;
        },
      )
      .nullable()
      // min(ref) 는 비교 대상이 비어 있어도 실패한다. 시작일을 안 넣고 종료일만 고르면
      // 걸리는데, 이 칸들은 유지보수 프로젝트가 아니면 화면에 아예 없다.
      // 그래서 보이지도 않는 칸 때문에 저장이 막혔다. 둘 다 있을 때만 비교한다.
      .test('mtnFreeEndDt-after-start', '무상유지보수 종료일을 확인하세요', function (value) {
        const start = this.parent?.mtnFreeStrtDt;
        if (!value || !start) return true;
        return new Date(value) >= new Date(start);
      })
      .default(undefined),

    collCondt: yup.string().nullable(''),
    payCondt: yup.string().nullable(''),
    comment: yup.string().nullable(''),

    // 사용자 권한(MINUS_PO)이 있다면 min 적용 안함. 권한 없으면 min 적용
    roProfitAmt: yup
      .number()
      .test('roProfitAmt-min', '최소 0이상 입력하세요', function (value) {
        const result = !isAuth && value < 0 ? false : true;
        return result;
      }),
    roCostAmt: yup
      .number()
      .test('roCostAmt-min', '최소 0이상 입력하세요', function (value) {
        const result = !isAuth && value < 0 ? false : true;
        return result;
      }),
    roInternalCosts: yup.array().of(
      yup.object().shape({
        roPartnerUsrNm: yup
          .string('')
          .when('roInternalAmt', (roInternalAmt, schema) => {
            if (roInternalAmt)
              return schema.required('협업담당자를 입력하세요');
          }),
        roInternalAmt: yup
          .number()
          .test('roInternalAmt-min', '최소 0이상 입력하세요', function (value) {
            const result = !isAuth && value < 0 ? false : true;
            return result;
          }),
      }),
    ),
  });

  const formik = useFormik({
    initialValues: initialValues,
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: async (values, { setSubmitting }) => {
      setSubmitting(true);

      const stepError = finalApprovalYn ? '' : validateApprovalSteps(approvalSteps, user?.usrUuid);
      if (stepError) {
        setApprovalStepsError(stepError);
        setMessage(stepError);
        setVisible(true);
        setSubmitting(false);
        return;
      }

      //console.log(dataToSubmit,'data');
      onEditOrder(values);
      onClose();
      setSubmitting(false);
    },
  });

  /**
   * 저장이 조용히 막히는 것을 없앤다.
   *
   * 검증에 걸리면 formik 은 저장을 하지 않고 아무 일도 하지 않는다. 메시지는 항목 아래에
   * 뜨지만, 그 항목이 화면에 없으면(유지보수 프로젝트가 아닐 때 감춰지는 날짜 칸 등)
   * 화면에는 아무 변화가 없다. 사용자에게는 저장 버튼이 죽은 것으로 보인다.
   * 걸린 항목을 모아 한 번에 알려준다.
   */
  useEffect(() => {
    if (!formik.submitCount || formik.isValidating || formik.isValid) return;
    const text = describeFormErrors(formik.errors, ORDER_FIELD_LABELS);
    if (text) {
      setMessage(text);
      setVisible(true);
    }
  }, [formik.submitCount, formik.isValidating]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleApprovalLineChange = (nextLineId) => {
    const selectedLine = approvalLineList.find((line) => line.lineId === nextLineId);
    if (!selectedLine) {
      setLineId('');
      setApprovalSteps(['']);
      return;
    }

    setLineId(nextLineId);
    setApprovalSteps(getLineStepValues(selectedLine, user?.usrUuid));
    setApprovalStepsError('');
  };

  const handleApprovalStepsChange = (steps) => {
    setApprovalSteps(steps);
    if (lineId) {
      setLineId('');
    }
    if (approvalStepsError) {
      setApprovalStepsError('');
    }
  };

  useEffect(() => {
    if (receiveOrderInf) {
      formik.setFieldValue(
        'roAdjProfitAmtPercent',
        getPercentByTotal(receiveOrderInf?.roAdjProfitAmt),
      );
      formik.setFieldValue(
        'roCostAmtPercent',
        getPercentByTotal(receiveOrderInf?.roCostAmt),
      );
    }
  }, [receiveOrderInf]);

  //valid 가 맞지 않을 때 스크롤.
  useEffect(() => {
    if (!formik?.isValid) {
      scollToRef.current?.scrollIntoView();
    }
  }, [formik?.isValid]);

  function getReceiveOrderInf(values) {
    // const dateDif = dayjs(values.mtnFreeEndDt) - dayjs(values.mtnFreeStrtDt);
    // const cDay = 24 * 60 * 60 * 1000;
    // const cMonth = cDay * 30; // 월 만듬
    // const difMonth = Math.ceil(dateDif / cMonth);
    //console.log(difMont,'dif');

    let ReceiveOrderInf = {
      roUuid: receiveOrderInf.roUuid,
      prjUuid: receiveOrderInf.prjUuid,
      partnerUuid: receiveOrderInf.partnerUuid,
      employeeUuid: receiveOrderInf.employeeUuid,
      partnerInc: receiveOrderInf.partnerInc,
      chargeNm: receiveOrderInf.chargeNm,
      salesUuid: receiveOrderInf.salesUuid,
      //mtnFreeTm: difMonth,
      collCondt: values.collCondt,
      payCondt: values.payCondt,
      comment: values.comment,
      expDay: values.expDay ? dayjs(values.expDay).format('YYYY-MM-DD') : null,
      siDt: values.siDt ? dayjs(values.siDt).format('YYYY-MM-DD') : null,

      inspectCond: values.inspectCond,
      dlvryDuedate: values.dlvryDuedate
      ? dayjs(values.dlvryDuedate).format('YYYY-MM-DD')
      : null,

      mtnFreeStrtDt: values.mtnFreeStrtDt
        ? dayjs(values.mtnFreeStrtDt).format('YYYY-MM-DD')
        : null,
      mtnFreeEndDt: values.mtnFreeEndDt
        ? dayjs(values.mtnFreeEndDt).format('YYYY-MM-DD')
        : null,

      licStrtDt: values.licStrtDt
        ? dayjs(values.licStrtDt).format('YYYY-MM-DD')
        : null,

      licEndDt: values.licEndDt
        ? dayjs(values.licEndDt).format('YYYY-MM-DD')
        : null,

      giPrePct: values.giPrePct, //보증보험(선급금 비율율)
      giCovPct: values.giCovPct, //보증보험(계약이행 비율)
      giMtnPct: values.giMtnPct, //보증보험(하자유지보수 비율)

      roProfitAmt: values.roProfitAmt, //매출이익
      roProfitAmtPercent: values.roProfitAmtPercent, //매출이익 퍼센트
      roCostAmt: values.roCostAmt,
      roCostAmtPercent: values.roCostAmtPercent,
      roAdjProfitAmt: values.roAdjProfitAmt,
      roAdjProfitAmtPercent: values.roAdjProfitAmtPercent,
      roTotalAmt: chance.totalSales, //총 매출액
      roInternalCosts: values.roInternalCosts, //내부거래비용array
    };
    return ReceiveOrderInf;
  }

  const onFileSave = async (value, orderInfo) => {
    let formData = new FormData();
    formData.append('fileDt', value.file);
    formData.append('fileTyp', 'PROJECT_PO');
    formData.append('fileAttrVal1', orderInfo.prjUuid);
    formData.append('fileAttrVal2', '수주품의서');
    formData.append('fileAttrVal3', orderInfo.roUuid);
    formData.append('fileDesc', value.fileDesc);
    //console.log(formData, 'formData');

    try {
      const response = await fileApi.addFiles(formData);

      if (response.data.result === 'success') {
        enqueueSnackbar('수주품의서 파일 업로드 성공', {
          variant: 'success',
        });
      }
    } catch (err) {
      let message =
        typeof err.response !== 'undefined'
          ? err.response.data.message
          : err.message;
      enqueueSnackbar(message, {
        variant: 'error',
      });
    }
  };

  const onEditOrder = async (values) => {
    const orderLetterInfo = getReceiveOrderInf(values);
    //console.log(orderLetterInfo, 'orderLetterInfo');

    let dataToSubmit = {
      receiveOrderInf: orderLetterInfo,
//      billInfList: billInfList,
      billInfList: billInfListData,
      billInvList: billInvListData,
      lineId: finalApprovalYn ? undefined : lineId || approvalV2Doc?.lineId || undefined,
      approverUuids: finalApprovalYn ? [] : normalizeApprovalSteps(approvalSteps, user?.usrUuid),
      finalApprovalYn: finalApprovalYn ? 'Y' : 'N',
      finalApprovalComment: finalApprovalYn ? finalApprovalComment : undefined,
    };

    try {
      const res = await projectApi.editReceiveOrder(roUuid, dataToSubmit);

      if (res.data) {
        //실제 업로드 파일이 있다면
        if (values.files.length > 0 && values.files[0].file !== null) {
          values.files.forEach((value) => {
            onFileSave(value, res.data.receiveOrderInf);
          });
        }

        dispatch(setOrderLetter(res.data));
        enqueueSnackbar(`수주품의서 저장 성공`, {
          variant: 'success',
        });
      }
    } catch (err) {
      let message =
        err.response !== 'undefined' ? err.response.data.message : err.message;
      enqueueSnackbar(message, {
        variant: 'error',
      });
    }
  };

  const [visible, setVisible] = useState(false);
  const [message, setMessage] = useState(null);

  const onCancle = () => {
    setVisible(false);
  };

  const onConfirm = () => {
    setVisible(false);
  };

  const onClose = () => {
    formik.resetForm();
    setApprovalStepsError('');
    setFinalApprovalYn(false);
    setFinalApprovalComment('');
    handleClose();
  };

  const [removeVisible, setRemoveVisible] = useState(false);
  const handleDelete = () => {
    setRemoveVisible(true);
  };
  const onDeleteCancle = () => {
    setRemoveVisible(false);
  };
  const onDeleteConfirm = () => {
    //삭제
    handleDeleteAppr();
    setRemoveVisible(false);
  };

  const handleDeleteAppr = async () => {
    try {
      if (approvalV2Doc?.apprDocId) {
        await projectApi.recallReceiveOrderApprovalV2(roUuid);
        dispatch(listOrderLetters(chance.prjUuid));
        onClose();
        enqueueSnackbar('approval v2 결재를 회수했습니다.', {
          variant: 'success',
        });
        return;
      }

      const docuId = approvalList[0]?.docuUuid;
      const res = await approvalApi.deleteApproval(docuId);

      if (res.data.result === 'success') {
        dispatch(listOrderLetters(chance.prjUuid));
        onClose();
        enqueueSnackbar('결제가 삭제되었습니다', {
          variant: 'success',
        });
      } else {
        enqueueSnackbar('결제 삭제에 실패하였습니다.', {
          variant: 'error',
        });
      }
    } catch (err) {
      let message =
        typeof err.response !== 'undefined'
          ? err.response.data.message
          : err.message;
      enqueueSnackbar(message, {
        variant: 'error',
      });
    }
  };
//console.log(receiveOrderInf);
  return (
    <>
      <OrderBookModal
        type={type}
        open={open}
        chance={chance}
        handleClose={onClose}
        orderInfo={receiveOrderInf}
        roUuid={receiveOrderInf?.roUuid}
        formik={formik}
        user={user}
        lineId={lineId}
        approvalSteps={approvalSteps}
        approvalLines={approvalLineList}
        approvalLineLoading={approvalLineLoading}
        currentUserUuid={user?.usrUuid}
        approvalStepsError={approvalStepsError}
        setLineId={handleApprovalLineChange}
        setApprovalSteps={handleApprovalStepsChange}
        approvalList={approvalList}
        approvalV2Doc={approvalV2Doc}
        approvalV2Steps={approvalV2Steps}
        approvalV2Actions={approvalV2Actions}
        finalApprovalAvailable={Boolean(finalApprovalAuth)}
        finalApprovalYn={finalApprovalYn}
        finalApprovalComment={finalApprovalComment}
        setFinalApprovalYn={setFinalApprovalYn}
        setFinalApprovalComment={setFinalApprovalComment}
        scollToRef={scollToRef}
        salesDetails={salesDetails}
        purchaseDetails={purchaseDetails}
        onDeleteApproval={handleDelete}
      />
      <AskDialog
        visible={visible}
        title="확인"
        description={message}
        confirmText="확인"
        onConfirm={onConfirm}
        onCancle={onCancle}
      />
      <AskDialog
        visible={removeVisible}
        title="결재 삭제"
        description="해당 결재를  삭제 처리 하시겠습니까?(복구 불가)"
        onConfirm={onDeleteConfirm}
        onCancle={onDeleteCancle}
      />
    </>
  );
};

export default OrderBookEditModalContainer;
